import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { InputGroup, Input, InputGroupAddon, Button, Row, Col } from 'reactstrap'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faUserPlus,
    faSearch
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faUserPlus)
library.add(faSearch)

class UserSearchBox extends Component {
    static propTypes = {
        user: PropTypes.object,
        dispatch: PropTypes.func,
        action: PropTypes.func,
        onFiltered: PropTypes.func,
    }

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            staffId: ''
        }

        this.filter = null;
    }

    onUserSearchChange = (type, e) => {
        const { dispatch, action, user, onFiltered } = this.props

        let reg = new RegExp(e.target.value, 'i')
        this.filter = {
            byid: {},
            list: []
        }
        let { byid, list } = user;

        if (type === 'staff') {
            let matched = 0
            list.forEach((id) => {
                let _e = byid[id]
                if (reg.test(_e.staffId)) {
                    matched++
                    this.filter.byid[id] = _e
                    this.filter.list.push(id)
                }
            });
            if (!matched) {
                if (e.target.value !== '') {
                    dispatch(action(0))
                    this.setState({ staffId: e.target.value, name: '' })
                    onFiltered(this.filter);
                } else {
                    dispatch(action(list.length))
                    this.setState({ staffId: e.target.value, name: '' })
                    onFiltered(null);
                }
            } else {
                dispatch(action(matched))
                this.setState({ staffId: e.target.value, name: '' })
                onFiltered(this.filter);
            }
            return;
        }

        if (type === 'name') {
            let matched = 0
            list.forEach((id) => {
                let _e = byid[id]
                if (reg.test(_e.name)) {
                    matched++
                    this.filter.byid[id] = _e
                    this.filter.list.push(id)
                }
            })
            if (!matched) {
                if (e.target.value !== '') {
                    dispatch(action(0))
                    this.setState({ staffId: '', name: e.target.value })
                    onFiltered(this.filter);
                } else {
                    dispatch(action(list.length))
                    this.setState({ staffId: '', name: e.target.value })
                    onFiltered(null);
                }
            } else {
                dispatch(action(matched));
                this.setState({ adminstaffIdStaff: '', name: e.target.value });
                onFiltered(this.filter);
            }
            return;
        }
    }
    onUserSearch = (box) => {
        const { dispatch, action, onFiltered } = this.props
        if (box === 'staff') {
            onFiltered(this.filter);
        }
        if (box === 'name') {
            onFiltered(this.filter);
        }
        if (this.filter)
            dispatch(action(this.filter.list.length))
    }

    render() {
        const { name, staffId } = this.state;
        //console.log(this.props.user)
        return (
            <Row style={{ marginBottom: "10px" }}>
                <Col>
                    <InputGroup size="sm">
                        <Input placeholder="Staff No." value={staffId} onChange={(e) => { this.onUserSearchChange('staff', e) }} />
                        <InputGroupAddon addonType="append">
                            <Button onClick={() => { this.onUserSearch('staff') }}  >
                                <FontAwesomeIcon icon="search" />
                            </Button>
                        </InputGroupAddon>
                    </InputGroup>
                </Col>
                <Col>
                    <InputGroup size="sm">
                        <Input placeholder="Name" value={name} onChange={(e) => { this.onUserSearchChange('name', e) }} />
                        <InputGroupAddon addonType="append">
                            <Button onClick={() => this.onUserSearch('name')} >
                                <FontAwesomeIcon icon="search" />
                            </Button>
                        </InputGroupAddon>
                    </InputGroup>
                </Col>
            </Row>
        )
    }
}

export default UserSearchBox;



// WEBPACK FOOTER //
// ./src/components/blocks/UserSearchBox/UserSearchBox.js